import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const GlobalSearch = ({ placeholder, compact = false }) => {
  const { language, setSearchQuery } = useApp();
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const ph = placeholder || (
    language === 'ur' ? 'شاعری، شاعر، زمرہ تلاش کریں…'
    : language === 'hi' ? 'शायरी, शायर, श्रेणी खोजें…'
    : language === 'es' ? 'Buscar shayari, poeta, categoría…'
    : language === 'fr' ? 'Rechercher shayari, poète, catégorie…'
    : 'Search shayari, poet, category…'
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setSearchQuery(q.trim());
    navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <form onSubmit={handleSubmit} className={`global-search ${compact ? 'global-search--compact' : ''}`} dir={language === 'ur' ? 'rtl' : 'ltr'}>
      <span className="global-search__icon">🔍</span>
      <input
        type="text"
        value={q}
        onChange={e => setQ(e.target.value)}
        placeholder={ph}
        className="global-search__input"
      />
      {q && (
        <button type="button" className="global-search__clear" onClick={() => setQ('')}>✕</button>
      )}
      <button type="submit" className="global-search__btn">
        {language === 'ur' ? 'تلاش' : language === 'hi' ? 'खोजें' : language === 'es' ? 'Buscar' : language === 'fr' ? 'Chercher' : 'Search'}
      </button>
    </form>
  );
};

export default GlobalSearch;
